"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* Simple class to hold any default values for form fields
*/

var defaultValues = {
  additional_applicants_number: 0
};

exports.default = defaultValues;


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/common/InitialValues.js
// module id = 60
// module chunks = 0